<div>
  <p-table [value]="users" styleClass="text-xs" [tableStyle]="{ 'min-width': '50rem' }">
    <ng-template pTemplate="header">
      <tr>
        <th>Nome</th>
        <th>Email</th>
        @if ( componentType !== UserAdminComponentTypeEnum.BLOCKED) {
          <th>Estado</th>
        }
        @if ( componentType !== UserAdminComponentTypeEnum.BLOCKED) {
          <th>Privilégio</th>
        }
        @if (componentType === UserAdminComponentTypeEnum.BLOCKED) {
          <th>Início</th>
          <th>Fim</th>
        }
        <th>Data de Criação</th>
        <th>Açcões</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-user>

      <tr class="text-sm">
        <td>{{ user.firstname | titlecase}} {{user.lastname | titlecase}}</td>
        <td>{{ user.email }}</td>
        @if ( componentType !== UserAdminComponentTypeEnum.BLOCKED) {
          <td>{{ user.status.description | titlecase }}</td>
        }
        @if ( componentType !== UserAdminComponentTypeEnum.BLOCKED) {
          <td>{{ user.role.description | titlecase }}</td>
        }
        @if (componentType === UserAdminComponentTypeEnum.BLOCKED) {
          <td>{{ user.sanctionStart | date:'dd-MM-yyyy' }}</td>
          <td>{{ user.sanctionEnd | date:'dd-MM-yyyy' }}</td>
        }
        <td>{{ user.creationDate | date:'yyyy-MM-dd' }}</td>
        <td><i (click)="selectObjectForDropDown(user) ; setMouseEvent($event)" class="btn pi pi-cog cursor-pointer"></i>
      </td>
    </tr>
  </ng-template>
</p-table>

@if (!hasEvents) {
  <p class="flex justify-center text-sm text-gray-500 font-medium my-10">Nenhuma ocorrência foi
  encontrada, por favor verifique os filtros</p>
}
</div>

@if (selectedUser) {
  <app-user-drop-down [componentType]="componentType" [user]="selectedUser" [clickEvent]="mouseEvent"
    (onBlockSuccessEmitter)="updateUserFromTable($event)"
    (onUnBlockSuccessEmitter)="removeEventFromList($event)"
  (onRoleChanceSuccess)="onApiRoleChangeSuccess($event)"></app-user-drop-down>
}
